module.exports = __webpack_public_path__ + "static/media/catering.a9cd290e.svg";